"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSelect = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CardSelect = function CardSelect(_ref) {
  var backgroundColor = _ref.backgroundColor,
      image = _ref.image,
      label = _ref.label,
      selected = _ref.selected,
      colorSelected = _ref.colorSelected,
      size = _ref.size,
      onClick = _ref.onClick;
  var useStyles = (0, _styles.makeStyles)(function (theme) {
    return {
      rootSmall: {
        boxShadow: 'none',
        cursor: 'pointer',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'center',
        width: 64,
        height: 72
      },
      rootLarge: {
        boxShadow: 'none',
        cursor: 'pointer',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'center',
        width: 80,
        height: 86
      },
      media: {
        backgroundColor: backgroundColor,
        border: '1px solid rgba(0, 0, 0, 0.23)',
        position: 'relative',
        '&:hover div': {
          backgroundColor: 'rgba(0, 0, 0, 0.03)'
        },
        '&:focus div': {
          backgroundColor: 'transparent'
        }
      },
      small: {
        borderRadius: "".concat(theme.shape.borderRadius, "px"),
        height: '48px',
        width: '48px'
      },
      large: {
        borderRadius: "".concat(theme.shape.borderRadius, "px"),
        height: '64px',
        width: '64px'
      },
      imageOverlay: {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        position: 'absolute',
        borderRadius: theme.shape.borderRadius
      },
      checkOverlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '100%',
        borderRadius: theme.shape.borderRadius,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: colorSelected === 'white' ? theme.palette.background.paper : '#000000'
      },
      labelWrapper: {
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        marginTop: 2,
        fontSize: 12,
        minHeight: 20,
        '&:last-child': {
          paddingBottom: '0'
        }
      },
      imgSize: {
        width: '99%',
        position: 'relative'
      }
    };
  });
  var classes = useStyles();

  var renderHover = function renderHover() {
    return null || !image && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(classes.imageOverlay, " ").concat(classes[size])
    });
  };

  var renderImage = function renderImage() {
    return null || image && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: image,
      alt: "-",
      className: "".concat(classes[size], " ").concat(classes.imgSize)
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(classes.imageOverlay, " ").concat(classes[size])
    }));
  };

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      inHover = _React$useState2[0],
      setHover = _React$useState2[1];

  var renderCheck = function renderCheck() {
    return selected && /*#__PURE__*/_react.default.createElement("span", {
      className: classes.checkOverlay,
      onMouseEnter: function onMouseEnter() {
        return setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      }
    }, inHover ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_icons.Close, null)) : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_icons.Check, null)));
  };

  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: size === 'small' ? classes.rootSmall : classes.rootLarge,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    className: "".concat(classes.media, " ").concat(classes[size])
  }, renderHover(), renderImage(), renderCheck()), /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.labelWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption"
  }, label)));
};

exports.CardSelect = CardSelect;
CardSelect.propTypes = {
  image: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  label: _propTypes.default.string,
  selected: _propTypes.default.bool,
  colorSelected: _propTypes.default.oneOf(['black', 'white']),
  size: _propTypes.default.oneOf(['small', 'large']),
  onClick: _propTypes.default.func
};
CardSelect.defaultProps = {
  backgroundColor: '#ffffff',
  image: null,
  label: '',
  selected: false,
  colorSelected: 'black',
  size: 'small',
  onClick: function onClick() {
    return null;
  }
};